import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ResizerService } from 'ZalamoLibrary/src/lib/core/image/resizer.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-ai-challange',
    templateUrl: './ai-challange.component.html',
    styleUrls: ['./ai-challange.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AiChallangeComponent implements OnInit {
  loading$ = new BehaviorSubject(false);

  constructor() {}

  ngOnInit(): void {}

  async picked($event: { target: HTMLInputElement }) {
    this.loading$.next(true);
    const files = Array.from($event.target.files);
    const limit = 5;
    if (files.length > limit) {
      alert(`You can't upload more than ${limit} files`);
      this.loading$.next(false);
      return;
    }
    for (const fileBlob of files) {
      const currentDimenstions = await createImageBitmap(fileBlob).then(
        (bitmap) => {
          return {
            width: bitmap.width,
            height: bitmap.height,
          };
        },
      );
      const file =
        currentDimenstions.width > 2000 || currentDimenstions.height > 2000
          ? await ResizerService.resize(fileBlob, currentDimenstions, {
              width: 2000,
              height: 2000,
            }).then((res) => res.data)
          : fileBlob;
      const res = await fetch(`${environment.imagesUrl}/aikiller`, {
        body: file,
        method: 'PUT',
      }).then((res) => res.blob());

      const img = URL.createObjectURL(res);
      const a = document.createElement('a');
      a.href = img;
      a.download = 'aikiller.jpg';
      a.click();
    }
    this.loading$.next(false);
  }
}
